export default __webpack_public_path__ + "static/media/feralgrowl.afb1763c.png";